import { PagedResult, Result, NewsEvent } from "../models/index";
import { ServiceBase } from './ServiceBase';

export class SearchIn {
    keywords: string;
    path: string;

    constructor() {
        this.keywords = '';
        this.path = '';
    }

    public static fromInput(input: Partial<SearchIn>) {
        var result = new SearchIn();
        result = { ...result, ...input };
        return result;
    }
}

export class NewsEventService extends ServiceBase {

    public static async search(filters: SearchIn, pageSize: number, offset: number): Promise<Result<PagedResult<NewsEvent>>> {

        let searchDto = filters;

        let payload = { ...searchDto, pageSize, offset };

        var result = await this.requestJson<PagedResult<NewsEvent>>({
            url: `/api/NewsEvents/List`,
            method: "POST",
            data: payload
        });

        return result;
    }   
}